import React from 'react';
import { Box, Typography } from '@mui/material';
import { LwButton, LWModal } from 'redesign';
import { CompanyOrt } from '@types';
import { CompanyOrtForm } from '../../../../forms/company-ort-form';

type EmptyOrtListProps = {
  showModal: boolean;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  editingOrt: CompanyOrt | undefined;
  companyId: string;
  t: (key: string, options?: any) => string;
};

export const EmptyOrtList = ({
  showModal,
  handleOpenModal,
  handleCloseModal,
  editingOrt,
  companyId,
  t,
}: EmptyOrtListProps) => (
  <>
    <Box p={4}>
      <Typography gutterBottom>
        {t('company_ort_table.empty_message', { ns: 'hq-screen-specific' })}
      </Typography>
      <LwButton color="secondary" sx={{ width: 100 }} onClick={handleOpenModal}>
        Add
      </LwButton>
    </Box>

    <LWModal isOpen={showModal} onClose={handleCloseModal} testId="ort-modal">
      {showModal && (
        <CompanyOrtForm onClose={handleCloseModal} ort={editingOrt} companyId={companyId} />
      )}
    </LWModal>
  </>
);
